<template>
    <ProjectDescriptionText :jsonData="musicData" :basePath="'/music'" />
</template>

<script>  
    import ProjectDescriptionText from "../components/ProjectDescriptionText.vue"
    import musicData from '@/assets/data/music.json';

    export default {
        name: 'Music',
        components: {
            ProjectDescriptionText
        },
        data() {
            return {
                musicData
            }
        }
    }
</script>